module.exports = __webpack_public_path__ + "img/1928-44-NAACP.f9bc8cee.jpg";